var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// packages/retry-plugin/src/constant.ts
var defaultRetries = 3;
var defaultRetryDelay = 1e3;
var PLUGIN_IDENTIFIER = "[ Module Federation RetryPlugin ]";

// packages/retry-plugin/src/logger.ts
import { createLogger } from "@module-federation/sdk";
var logger = createLogger(PLUGIN_IDENTIFIER);
var logger_default = logger;

// packages/retry-plugin/src/fetch-retry.ts
async function fetchWithRetry({ url, options = {}, retryTimes = defaultRetries, retryDelay = defaultRetryDelay, fallback }) {
  try {
    const response = await fetch(url, options);
    const responseClone = response.clone();
    if (!response.ok) {
      throw new Error(`Server error\uFF1A${response.status}`);
    }
    await responseClone.json().catch((error) => {
      throw new Error(`Json parse error: ${error}, url is: ${url}`);
    });
    return response;
  } catch (error) {
    if (retryTimes <= 0) {
      logger_default.log(`${PLUGIN_IDENTIFIER}: retry failed after ${retryTimes} times for url: ${url}, now will try fallbackUrl url`);
      if (fallback && typeof fallback === "function") {
        return fetchWithRetry({
          url: fallback(url),
          options,
          retryTimes: 0,
          retryDelay: 0
        });
      }
      if (error instanceof Error && error.message.includes("Json parse error")) {
        throw error;
      }
      throw new Error(`${PLUGIN_IDENTIFIER}: The request failed three times and has now been abandoned`);
    } else {
      retryDelay > 0 && await new Promise((resolve) => setTimeout(resolve, retryDelay));
      logger_default.log(`Trying again. Number of retries available\uFF1A${retryTimes - 1}`);
      return await fetchWithRetry({
        url,
        options,
        retryTimes: retryTimes - 1,
        retryDelay,
        fallback
      });
    }
  }
}
__name(fetchWithRetry, "fetchWithRetry");

// packages/retry-plugin/src/util.ts
function scriptCommonRetry({ scriptOption, moduleInfo, retryFn, beforeExecuteRetry = /* @__PURE__ */ __name(() => {
}, "beforeExecuteRetry") }) {
  return async function(...args) {
    let retryResponse;
    const { retryTimes = defaultRetries, retryDelay = defaultRetryDelay } = scriptOption || {};
    if (scriptOption?.moduleName && scriptOption?.moduleName.some((m) => moduleInfo.name === m || moduleInfo?.alias === m) || scriptOption?.moduleName === void 0) {
      let attempts = 0;
      while (attempts - 1 < retryTimes) {
        try {
          beforeExecuteRetry();
          retryResponse = await retryFn(...args);
          break;
        } catch (error) {
          attempts++;
          if (attempts - 1 >= retryTimes) {
            scriptOption?.cb && await new Promise((resolve) => scriptOption?.cb && scriptOption?.cb(resolve, error));
            throw error;
          }
          logger_default.log(`${PLUGIN_IDENTIFIER}: script resource retrying ${attempts} times`);
          await new Promise((resolve) => setTimeout(resolve, retryDelay));
        }
      }
    }
    return retryResponse;
  };
}
__name(scriptCommonRetry, "scriptCommonRetry");

// packages/retry-plugin/src/index.ts
var RetryPlugin = /* @__PURE__ */ __name(({ fetch: fetchOption, script: scriptOption }) => ({
  name: "retry-plugin",
  async fetch(url, options) {
    const _options = {
      ...options,
      ...fetchOption?.options
    };
    if (fetchOption) {
      if (fetchOption.url) {
        if (url === fetchOption?.url) {
          return fetchWithRetry({
            url: fetchOption.url,
            options: _options,
            retryTimes: fetchOption?.retryTimes,
            fallback: fetchOption?.fallback
          });
        }
      } else {
        return fetchWithRetry({
          url,
          options: _options,
          retryTimes: fetchOption?.retryTimes,
          fallback: fetchOption?.fallback
        });
      }
    }
    return fetch(url, options);
  },
  async loadEntryError({ getRemoteEntry, origin, remoteInfo, remoteEntryExports, globalLoading, uniqueKey }) {
    if (!scriptOption)
      return;
    const retryFn = getRemoteEntry;
    const beforeExecuteRetry = /* @__PURE__ */ __name(() => delete globalLoading[uniqueKey], "beforeExecuteRetry");
    const getRemoteEntryRetry = scriptCommonRetry({
      scriptOption,
      moduleInfo: remoteInfo,
      retryFn,
      beforeExecuteRetry
    });
    return getRemoteEntryRetry({
      origin,
      remoteInfo,
      remoteEntryExports
    });
  },
  async getModuleFactory({ remoteEntryExports, expose, moduleInfo }) {
    if (!scriptOption)
      return;
    const retryFn = remoteEntryExports.get;
    const getRemoteEntryRetry = scriptCommonRetry({
      scriptOption,
      moduleInfo,
      retryFn
    });
    return getRemoteEntryRetry(expose);
  }
}), "RetryPlugin");
export {
  RetryPlugin
};
